import type { MouseEventHandler } from 'react';

import { Icon } from 'components/Icon/Icon';

import {
  CmsTileModalCloseButtonStyled,
  CmsTileModalCloseButtonText,
} from './CmsTileModalCloseButton.styled';

type Props = {
  onClick: MouseEventHandler<HTMLButtonElement>;
};

export function CmsTileModalCloseButton({ onClick }: Props) {
  return (
    <CmsTileModalCloseButtonStyled
      type="button"
      data-qa-id="cms-tile-grid-close-button"
      onClick={onClick}
    >
      <CmsTileModalCloseButtonText>
        {getText('close')}
      </CmsTileModalCloseButtonText>

      <Icon name="close" size={24} />
    </CmsTileModalCloseButtonStyled>
  );
}
